import React from 'react';

const MsToString = (props) => {
  const { ms, fixed } = props;
  const _fixed = fixed === undefined ? 1 : fixed;

  const isSeconds = (ms < 1000 * 60);
  const isMinutes = !isSeconds && (ms < 1000 * 60 * 60);
  const isHours = !isSeconds && !isMinutes && (ms < 1000 * 60 * 60 * 24);
  const isDays = !isSeconds && !isMinutes && !isHours;

  return (
    <span style={{ ...props.style }}>
      {isSeconds && (<>{(ms / 1000).toFixed(_fixed)}초</>)}
      {isMinutes && (<>{(ms / (1000 * 60)).toFixed(_fixed)}분</>)}
      {isHours && (<>{(ms / (1000 * 60 * 60)).toFixed(_fixed)}시간</>)}
      {isDays && (<>{(ms / (1000 * 60 * 60 * 24)).toFixed(_fixed)}일</>)}
    </span>
  );
};

export { MsToString };
